import React, { PropTypes, PureComponent } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { queryString } from 'lib/format';
import appConfig from '../../../config';
import SyndicatedPlayerAPIProxy from 'webapp/syndicated/SyndicatedPlayerAPIProxy';
import { espnPlayerSrcFilesSelector } from 'common/selectors/bootstrapSelector';

const {
    shellVersion,
    cdnHost,
    devStyles
} = appConfig;

const BASE_HREF = `${cdnHost}/redesign/${shellVersion}`;
let STYLE_HREF = `${BASE_HREF}/css`;
if (devStyles) {
    STYLE_HREF = 'http://localhost:8080/static/css';
}

const { PARTNER, DOMAIN } = SyndicatedPlayerAPIProxy;

const containerStyle = {
    padding: 20
};

const playerContainerStyle = {
    marginTop: 20
};

let iframeStyle = {
    width: 640,
    height: 360
};

class SyndicatedPlayerExample extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            id: '',
            gameId: '',
            league: '',
            network: '',
            position: 0,
            currentTime: 0,
            thumbnail: ''
        };
        this.playVideo = this.playVideo.bind(this);
        this.pauseVideo = this.pauseVideo.bind(this);
        this.muteStream = this.muteStream.bind(this);
        this.unMuteStream = this.unMuteStream.bind(this);
        this.setVideoPosition = this.setVideoPosition.bind(this);
        this.getVideoPosition = this.getVideoPosition.bind(this);
        this.enterFullScreen = this.enterFullScreen.bind(this);
        this.selectById = this.selectById.bind(this);
        this.selectByEventId = this.selectByEventId.bind(this);
        this.selectEventByNetworkName = this.selectEventByNetworkName.bind(this);
        this.selectEventByGameIdLeague = this.selectEventByGameIdLeague.bind(this);
        this.recheckAccess = this.recheckAccess.bind(this);
        this.adobePassLogout = this.adobePassLogout.bind(this);
        this.getAffiliate = this.getAffiliate.bind(this);
        this.getSelectedProvider = this.getSelectedProvider.bind(this);
        this.getAuthenticationStatus = this.getAuthenticationStatus.bind(this);
        this.onIdChange = this.onIdChange.bind(this);
        this.onEventIdChange = this.onEventIdChange.bind(this);
        this.onGameIdChange = this.onGameIdChange.bind(this);
        this.onLeagueChange = this.onLeagueChange.bind(this);
        this.onNetworkChange = this.onNetworkChange.bind(this);
        this.onPositionChange = this.onPositionChange.bind(this);
        this.onThumbnailChange = this.onThumbnailChange.bind(this);
        this.onPostMessage = this.onPostMessage.bind(this);
    }

    componentDidMount() {
        window.addEventListener('message', this.onPostMessage);
    }

    onPostMessage(event) {
        const { location: { query: { bridge = true } = {} } } = this.props;

        if (bridge === 'false') { // simulate iframe embed only mode
            return;
        }

        if (typeof event.data !== 'string') {
            return;
        }

        let data;
        try {
            const prefix = `${PARTNER}:${DOMAIN}:`;
            data = JSON.parse(event.data.substr(prefix.length));
        } catch (err) {
            data = {};
        }

        const { type, payload } = data;

        if (!type) {
            return;
        }

        const [partner, domain, apiName] = type.split(':');

        if (partner !== PARTNER) {
            return;
        }

        if (domain === DOMAIN) {
            switch (apiName) {
                case 'bridgeReady':
                    // send the parent location to the iframe player in case
                    // `document.referrer` is not available for domain check.
                    this.callAPI({
                        type: SyndicatedPlayerAPIProxy.PARENT_HOST,
                        payload: [window.location.href]
                    });
                    break;
                case 'getVideoPosition':
                    this.setState({ currentTime: payload });
                    break;
                case 'getAffiliate':
                case 'getSelectedProvider':
                case 'getAuthenticationStatus':
                    console.log(apiName, payload); // eslint-disable-line no-console
                    break;
                case 'authenticationSuccessful':
                case 'recheckAccess': {
                    let url = (payload && payload.href) || this.iframe.src;
                    const [host, searchStr] = url.split('?');
                    if (searchStr) {
                        const newSearchStr = searchStr.replace(/&autoStart(=[^&]*)?|^autoStart(=[^&]*)?&?/, '');
                        url = `${host}?${newSearchStr}`;
                    }
                    this.iframe.src = url;
                    break;
                }
                default:
                    break;
            }
        }
    }

    onIdChange(event) {
        this.setState({ id: event.target.value });
    }

    onEventIdChange(event) {
        this.setState({ eventId: event.target.value });
    }

    onGameIdChange(event) {
        this.setState({ gameId: event.target.value });
    }

    onLeagueChange(event) {
        this.setState({ league: event.target.value });
    }

    onThumbnailChange(event) {
        this.setState({ thumbnail: event.target.value });
    }

    onNetworkChange(event) {
        this.setState({ network: event.target.value });
    }

    onPositionChange(event) {
        this.setState({ position: parseInt(event.target.value, 10) });
    }

    setVideoPosition() {
        this.callAPI({
            type: SyndicatedPlayerAPIProxy.SET_CURRENT_TIME,
            payload: [this.state.position]
        });
    }

    getVideoPosition() {
        this.callAPI({
            type: SyndicatedPlayerAPIProxy.GET_CURRENT_TIME
        });
    }

    getAffiliate() {
        this.callAPI({
            type: SyndicatedPlayerAPIProxy.GET_AFFILIATE
        });
    }

    getSelectedProvider() {
        this.callAPI({
            type: SyndicatedPlayerAPIProxy.GET_SELECTED_PROVIDER
        });
    }

    getAuthenticationStatus() {
        this.callAPI({
            type: SyndicatedPlayerAPIProxy.GET_AUTH_STATUS
        });
    }

    playVideo() {
        this.callAPI({
            type: SyndicatedPlayerAPIProxy.PLAY
        });
    }

    pauseVideo() {
        this.callAPI({
            type: SyndicatedPlayerAPIProxy.PAUSE
        });
    }

    muteStream() {
        this.callAPI({
            type: SyndicatedPlayerAPIProxy.MUTE
        });
    }

    unMuteStream() {
        this.callAPI({
            type: SyndicatedPlayerAPIProxy.UNMUTE
        });
    }

    enterFullScreen() {
        this.callAPI({
            type: SyndicatedPlayerAPIProxy.ENTER_FULLSCREEN
        });
    }

    selectById() {
        this.callAPI({
            type: SyndicatedPlayerAPIProxy.SELECT_BY_ID,
            payload: [this.state.id, this.autoPlayForSelectById.checked, this.state.thumbnail]
        });
    }

    selectByEventId() {
        this.callAPI({
            type: SyndicatedPlayerAPIProxy.SELECT_BY_EVENT_ID,
            payload: [this.state.eventId, this.autoPlayForSelectByEventId.checked, this.state.thumbnail]
        });
    }

    selectEventByNetworkName() {
        this.callAPI({
            type: SyndicatedPlayerAPIProxy.SELECT_EVENT_BY_NETWORK_NAME,
            payload: [this.state.network, this.state.thumbnail]
        });
    }

    selectEventByGameIdLeague() {
        this.callAPI({
            type: SyndicatedPlayerAPIProxy.SELECT_EVENT_BY_GAME_ID,
            payload: [this.state.gameId, this.state.league, this.state.thumbnail]
        });
    }

    recheckAccess() {
        this.callAPI({
            type: SyndicatedPlayerAPIProxy.RECHECK_ACCESS
        });
    }

    adobePassLogout() {
        this.callAPI({
            type: SyndicatedPlayerAPIProxy.ADOBE_PASS_LOGOUT
        });
    }

    callAPI(data) {
        const originResult = /https?:\/\/[^\/]+/.exec(this.iframe.src);
        const origin = (originResult && originResult[0]) || '*';
        this.iframe.contentWindow.postMessage(JSON.stringify(data), origin);
    }

    render() {
        const {
            id,
            eventId,
            gameId,
            league,
            network,
            position,
            currentTime,
            thumbnail
        } = this.state;
        const {
            location: { query },
            espnPlayerSrc: {
                espnPlayerJsUrl,
                espnPlayerCssUrl
            }
        } = this.props;
        const { responsive, origin = '' } = query;
        let { width, height } = query;
        if (responsive) {
            width = '100%';
            height = '56.25vw';
        } else if (width && !height) {
            height = Math.round(width * (9 / 16));
        } else if (!width && height) {
            width = Math.round(height * (16 / 9));
        }
        iframeStyle = width && height ? { ...iframeStyle, width, height } : iframeStyle;
        const ifmQuery = { ...query };
        delete ifmQuery.bridge;
        delete ifmQuery.origin;
        const qs = queryString(ifmQuery);

        return (
            <div style={containerStyle}>
                <Helmet
                    meta={[
                        { name: 'robots', content: 'noindex, nofollow' }
                    ]}
                    link={[
                        { rel: 'stylesheet', href: `${STYLE_HREF}/page.css` },
                        {
                            class: '__watch-player-bundle__',
                            rel: 'stylesheet',
                            href: espnPlayerCssUrl
                        }
                    ]}
                    style={[{
                        cssText: `
                        body {
                            font-family: sans-serif;
                        }
                        h1 { font-size: 24px; }
                        h2 { font-size: 20px; }
                        h3 { font-size: 18px; }
                    `
                    }]}
                    script={[
                        {
                            src: espnPlayerJsUrl,
                            async: true
                        }
                    ]}
                />
                <h1>Syndicated Player Test</h1>
                <div>
                    <button onClick={this.playVideo}>playVideo</button>
                    <button onClick={this.pauseVideo}>pauseVideo</button>
                    <button onClick={this.muteStream}>muteStream</button>
                    <button onClick={this.unMuteStream}>unMuteStream</button>
                    <button onClick={this.enterFullScreen}>enterFullScreen</button>
                </div>
                <div>
                    <button onClick={this.setVideoPosition}>setVideoPosition</button>
                    <input type="text" value={position} onChange={this.onPositionChange} />
                    <button onClick={this.getVideoPosition}>getVideoPosition</button>
                    <input type="text" value={currentTime} readOnly />
                </div>
                <div>
                    <button onClick={this.selectById}>selectById</button>
                    <input type="text" value={id} onChange={this.onIdChange} />
                    <label htmlFor="autoplay">
                        Autoplay:
                        <input
                            ref={input => { this.autoPlayForSelectById = input; }}
                            id="autoplay"
                            type="checkbox"
                            defaultChecked
                            style={{ display: 'inline-block' }}
                        />
                    </label>
                    <span>Thumbnail: </span><input type="text" value={thumbnail} onChange={this.onThumbnailChange} />
                </div>
                <div>
                    <button onClick={this.selectByEventId}>selectByEventId</button>
                    <input type="text" value={eventId} onChange={this.onEventIdChange} />
                    <label htmlFor="autoplay">
                        Autoplay:
                        <input
                            ref={input => { this.autoPlayForSelectByEventId = input; }}
                            id="autoplay"
                            type="checkbox"
                            defaultChecked
                            style={{ display: 'inline-block' }}
                        />
                    </label>
                    <span>Thumbnail: </span><input type="text" value={thumbnail} onChange={this.onThumbnailChange} />
                </div>
                <div>
                    <button onClick={this.selectEventByNetworkName}>selectEventByNetworkName</button>
                    <input type="text" value={network} onChange={this.onNetworkChange} />
                </div>
                <div>
                    <button onClick={this.selectEventByGameIdLeague}>selectEventByGameIdLeague</button>
                    <span>GameId: </span><input type="text" value={gameId} onChange={this.onGameIdChange} />
                    <span>League: </span><input type="text" value={league} onChange={this.onLeagueChange} />
                    <span>Thumbnail: </span><input type="text" value={thumbnail} onChange={this.onThumbnailChange} />
                </div>
                <div>
                    <button onClick={this.recheckAccess}>recheckAccess</button>
                    <button onClick={this.adobePassLogout}>adobePassLogout</button>
                </div>
                <div>
                    <button onClick={this.getAffiliate}>getAffiliate</button>
                    <button onClick={this.getSelectedProvider}>getSelectedProvider</button>
                    <button onClick={this.getAuthenticationStatus}>getAuthenticationStatus</button>
                </div>
                <div style={playerContainerStyle}>
                    <iframe
                        ref={iframe => { this.iframe = iframe; }}
                        id="syndicated_player"
                        src={`${origin}/watch/syndicated/player${qs}`}
                        frameBorder="0"
                        allowFullScreen
                        style={iframeStyle}
                    />
                </div>
            </div>
        );
    }
}

SyndicatedPlayerExample.propTypes = {
    location: PropTypes.object,
    espnPlayerSrc: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
    espnPlayerSrc: espnPlayerSrcFilesSelector(state)
});

export default connect(mapStateToProps)(SyndicatedPlayerExample);




// WEBPACK FOOTER //
// ./app/webapp/page/SyndicatedPlayerExample.js